import {
  ApplicationHttpClient,
  applicationHttpClientCreator,
} from "@core/config/application-http-client/application-http-client";

import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { NgModule, Provider } from "@angular/core";

const customProviders: Provider[] = [
  {
    provide: ApplicationHttpClient,
    useFactory: applicationHttpClientCreator,
    deps: [HttpClient],
  },
];

@NgModule({
  providers: [...customProviders, provideHttpClient(withInterceptorsFromDi())],
})
export class AplicationHttpClientModule {}
